import type { ParentComponent } from "solid-js";
import { Show } from "solid-js";
import { isNil } from "lodash-es";
import type { StatusButtonProps } from "../button/StatusButton";
import StatusButton from "../button/StatusButton";

export type InlineMessageProps = {
  variant: "warning" | "danger" | "informative";
  label?: string;
  action?: Pick<StatusButtonProps, "label" | "onClick">;
  layout?: "row" | "column";
  class?: string;
};

const InlineMessage: ParentComponent<InlineMessageProps> = (props) => (
  <div
    class={props.class}
    classList={{
      "flex gap-4 rounded-sm p-2 text-base-regular wrap-break-word": true,
      "bg-surface-status-subtle-warning text-status-warning": props.variant === "warning",
      "bg-surface-status-subtle-danger text-status-danger": props.variant === "danger",
      "bg-surface-status-subtle-informative text-status-informative": props.variant === "informative",
      "flex-col": props.layout === "column",
      "items-center": props.layout !== "column",
    }}
  >
    <div class="w-full">{isNil(props.label) ? props.children : props.label}</div>
    <Show when={props.action}>
      {(actionProps) => (
        <div>
          <StatusButton variant="primary" status={props.variant} {...actionProps()} />
        </div>
      )}
    </Show>
  </div>
);

export default InlineMessage;
